import { restClient } from '@/Core'

import { LETTER_TEMPLATE_REST_URL } from '../Contracts/ILetter'

import type { ILetter } from '../Contracts/ILetter'

/**
 * Чернетка листа з шаблону (`SPEC-013` §6.1):
 * `POST /services/letter_templates/{uuid}/generate {entity: uuid}` → 201,
 * лист у статусі «Чернетка» зі змінними, підставленими в тему, адресатів і
 * тіло, і копіями вкладень шаблону (для документа — ще й його PDF).
 *
 * `entity` — uuid сутності провайдера шаблону: клієнта, перевізника,
 * контакту чи документа.
 */
export const GenerateLetterTask = async (templateUuid: string, entityUuid: string): Promise<ILetter> => {
    const response = (await restClient.post(
        `${LETTER_TEMPLATE_REST_URL}/${encodeURIComponent(templateUuid)}/generate`,
        { json: { entity: entityUuid } }
    )) as unknown

    if (response === null || typeof response !== 'object' || typeof (response as ILetter).uuid !== 'string') {
        throw new Error('Сервер не повернув створений лист.')
    }

    return response as ILetter
}
